import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {QuestionOverlayService} from "./pages/catalog-page/services/question-overlay/question-overlay.service";
import {ActionQuestionOverlayService} from "./pages/catalog-page/services/action-question-overlay/action-question-overlay.service";
import {SidebarMenuService} from "./core/services/sidebar-menu/sidebar-menu.service";
import {PageTitleService} from "./core/services/page-title/page-title.service";
import {NavigationDataService} from "./core/services/navigation-data/navigation-data.service";
import {PageParametersService} from "./core/services/page-parameters/page-parameters.service";
import {CatalogCustomElementService} from "./pages/catalog-page/services/catalog-custom-element/catalog-custom-element.service";
import {ChartService} from "./core/services/chart/chart.service";
import {MonacoEditorService} from "./core/services/monaco-editor/monaco-editor.service";
import {FeatureFlagsService} from "./core/services/feature-flag/feature-flags.service";
import {ThemeService} from "./core/services/theme/theme.service";
import {createCustomElement} from "@angular/elements";
import {MonacoEditorComponent} from "./core/components/monaco-editor/monaco-editor.component";
import {SiteHeaderComponent} from "./core/components/site-header/site-header.component";
import {FeatureFlagListComponent} from "./core/components/feature-flag-list/feature-flag-list.component";
import {FeatureOnComponent} from "./core/components/feature-on/feature-on.component";
import {FeatureOffComponent} from "./core/components/feature-off/feature-off.component";
import {ColourPickerComponent} from "./core/components/colour-picker/colour-picker.component";
import {ThemeContentComponent} from "./core/components/theme-content/theme-content.component";
import {CronExpressionInputComponent} from "./core/components/cron-expression-input/cron-expression-input.component";
import {ElapsedTimeComponent} from "./core/components/elapsed-time/elapsed-time.component";
import {KnockoutFormWrapperComponent} from "./core/components/knockout-form-wrapper/knockout-form-wrapper.component";
import {EmbeddedReportComponent} from "./core/components/embedded-report/embedded-report.component";
import {DeveloperMenuBarComponent} from './core/components/developer-menu-bar/developer-menu-bar.component';
import {TenancySelectionComponent} from './core/components/tenancy-selection/tenancy-selection.component';
import {CmdbDefaultInfoboxComponent} from "./pages/cmdb-page/components/cmdb-default-infobox/cmdb-default-infobox.component";
import {CmdbInfoboxComponent} from "./pages/cmdb-page/components/cmdb-infobox/cmdb-infobox.component";
import {RecordSyncService} from "./core/services/record-sync/record-sync.service";
import {GojsShapesService} from "./gojs/services/gojs-shapes/gojs-shapes.service";
import {ProgressDialogComponent} from "./core/components/progress-dialog/progress-dialog.component";
import {AuditHistoryService} from "./core/services/audit-history/audit-history.service";
import {AuditHistoryJournalFilterComponent} from "./core/components/journal/audit-history-journal-filter/audit-history-journal-filter.component";
import {WorkflowModalComponent} from "./pages/workflow-page/workflow-modal/workflow-modal.component";
import {TableGridComponent} from "./core/components/data-grids/table-grid/table-grid.component";
import {EmailTextfieldRendererComponent} from "./core/components/field-renderer/email-textfield-renderer/email-textfield-renderer.component";
import {TextFieldRendererComponent} from "./core/components/field-renderer/textfield-renderer/textfield-renderer.component";
import {ChoiceRendererComponent} from "./core/components/field-renderer/choice-renderer/choice-renderer.component";
import {DateRendererComponent} from "./core/components/field-renderer/date-renderer/date-renderer.component";
import {SwitchRendererComponent} from "./core/components/field-renderer/switch-renderer/switch-renderer.component";
import {OneToOneRendererComponent} from "./core/components/field-renderer/onetoone-renderer/onetoone-renderer.component";
import {PortalModalComponent} from "./pages/portal-page/portal-modal/portal-modal.component";
import {ImportTransformDiagramComponent} from "./core/components/import-transform-diagram/import-transform-diagram.component";
import {RoutingService} from "./core/services/routing/routing.service";
import {UserService} from "./core/services/user/user.service";
import {JournalAttachmentSelectorComponent} from "./core/components/journal/journal-attachment-selector/journal-attachment-selector.component";
import {ServerScriptMessagesComponent} from "./core/components/data-grids/server-script-messages/server-script-messages.component";
import {RtfEditorComponent} from "./core/components/rtf-editor/rtf-editor.component";
import {DetailTooltipComponent} from "./core/components/detail-tooltip/detail-tooltip.component";
import {RequestService} from "./core/services/request/request.service";
import {QuestionOverlayComponent} from "./pages/catalog-page/components/question-overlay/question-overlay.component";
import {
  ActionQuestionOverlayComponent
} from "./pages/catalog-page/components/action-question-overlay/action-question-overlay.component";
import {VersionTooltipComponent} from "./core/components/version-tooltip/version-tooltip.component";
import {
  SystemJournalEmailComponent
} from "./core/components/journal/system-journal-email/system-journal-email.component";
import {SystemJournalComponent} from "./core/components/journal/system-journal/system-journal.component";
import {TranslationService} from "./core/services/translation-service/translation-service";
import {SanitizeService} from "./core/services/sanitize/sanitize.service";
import {KnockoutNuclearFieldComponent} from "./core/components/knockout-nuclear-field/knockout-nuclear-field.component";
import {TableMetadataService} from "./core/services/table-metadata/table-metadata.service";
import {QuestionModalComponent} from "./pages/catalog-page/components/question-modal/question-modal.component";
import {InternationalizationService} from "./core/services/internationalization/internationalization.service";
import {LocaleSelectorComponent} from "./core/components/locale-selector/locale-selector.component";
import {LocalizeService} from "./core/services/internationalization/localize.service";
import {
  LocaleHtmlConfigurationComponent
} from "./core/components/locale-html-configuration/locale-html-configuration.component";

import {PortalService} from "./core/services/portal/portal.service";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {ModalWrapperComponent} from "./core/components/modal-wrapper/modal-wrapper.component";
import {DropDownListComponent} from "@syncfusion/ej2-angular-dropdowns";
import {QueryFunctionsComponent} from "./core/components/query-functions/query-functions.component";
import {AlertService} from "./core/services/alert/alert.service";
import {ImageLightboxComponent} from "./core/components/image-lightbox/image-lightbox.component";
import {ImageLightboxService} from "./core/services/image-lightbox/image-lightbox.service";
import {ExpandoComponent} from "./core/components/expando/expando.component";
import {SecondFactorAuthPageComponent} from "./pages/second-factor-auth-page/second-factor-auth-page.component";
import {KnowledgePageComponent} from "./pages/knowledge-page/knowledge-page.component";
import {ContentPageFooterComponent} from "./shared/components/content-page-footer/content-page-footer.component";
import {ContentPageHeaderComponent} from "./shared/components/content-page-header/content-page-header.component";
import {ContentDataService} from "./core/services/content-data/content-data.service";
import {EventService} from "./core/services/event/event.service";
import { LocationService } from './core/services/location/location.service';
import { debounceTime, filter, tap } from 'rxjs/operators';
import {
  SystemJournalWhatsappComponent
} from "./core/components/journal/system-journal-whatsapp/system-journal-whatsapp.component";
import {FeatureFlagResetComponent} from "./core/components/feature-flag-reset/feature-flag-reset.component";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  title = 'servicely-ng';

  pageName: string;
  servicelyVersion: string;
  modeName: string;
  noMenuMode: string;

  // We do this to support initialisation of the monaco editor before it is used anywhere, otherwise the
  // first use of a component that includes it does not have access to the window.monaco variable.
  // TODO see if this is still necessary
  monacoOptions = {};
  monacoCode = "";

  @ViewChild("navigateModalFormModal")
  navigateModalFormModal: DialogComponent;

  siteLoaderElement = document.querySelector('.site-loader') as HTMLElement;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sidebarMenuService: SidebarMenuService,
    private featureFlagsService: FeatureFlagsService,
    private pageTitleService: PageTitleService,
    private navigationDataService: NavigationDataService,
    private pageParameters: PageParametersService,
    private injector: Injector,
    private catalogCustomElementService: CatalogCustomElementService,
    private questionOverlayService: QuestionOverlayService,
    private actionQuestionOverlayService: ActionQuestionOverlayService,
    private chartService: ChartService,
    private monacoEditorService: MonacoEditorService,
    private themeService: ThemeService,
    private recordSyncService: RecordSyncService,
    private auditHistoryService: AuditHistoryService,
    private gojsShapesService: GojsShapesService,
    private routingService: RoutingService,
    private userService: UserService,
    private requestService: RequestService,
    private translationService: TranslationService,
    private tableMetadataService: TableMetadataService,
    private sanitizeService: SanitizeService,
    private internationalizationService: InternationalizationService,
    private localizeService: LocalizeService,
    private portalService: PortalService,
    private alertService: AlertService,
    private imageLightboxService: ImageLightboxService,
    private contentDataService: ContentDataService,
    private eventService: EventService,
    private locationService: LocationService,
  ) {
  }

  async ngOnInit() {

    // Initialise MonacoEnvironment - for ngx-monaco-editor 12
    let baseUrl = this.userService.getBaseUrl();
    if (baseUrl) {
      baseUrl = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/";
      (window as any).MonacoEnvironment = {
        getWorkerUrl: function (workerId, label) {
          return `data:text/javascript;charset=utf-8,${encodeURIComponent(`
      self.MonacoEnvironment = {
        baseUrl: '${baseUrl}scripts/assets/monaco/'
      };
      importScripts('${baseUrl}scripts/assets/monaco/vs/base/worker/workerMain.js');`)}`
        }
      };
    }

    this.pageName = this.pageParameters.pageName;
    this.servicelyVersion = this.pageParameters.servicelyVersion;
    this.modeName = this.pageParameters.modeName;
    this.noMenuMode = this.pageParameters.noMenuMode;

    this.localizeService.init(this.userService.getLanguage());
    this.internationalizationService.init(this.userService.getLanguage());

    this.featureFlagsService.init();
    this.sidebarMenuService.init();
    this.pageTitleService.init();
    await this.navigationDataService.init();
    this.questionOverlayService.init();
    this.actionQuestionOverlayService.init();

    this.chartService.init();

    this.recordSyncService.init();

    this.auditHistoryService.init();

    await this.monacoEditorService.init();

    this.gojsShapesService.init();

    this.translationService.init();

    await this.tableMetadataService.init();

    this.portalService.init();

    this.locationService.init();
    this.themeService.init();

    // Make components available to the knockout code. Note that it appears that the element name cannot be the same as
    // the Angular selector otherwise all components referenced explicitly in the Angular code will be doubled.

    this.defineIfNotExist('sb-ng-site-header', createCustomElement(SiteHeaderComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-monaco-editor', createCustomElement(MonacoEditorComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-feature-flag-list', createCustomElement(FeatureFlagListComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-feature-flag-reset', createCustomElement(FeatureFlagResetComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-feature-on', createCustomElement(FeatureOnComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-feature-off', createCustomElement(FeatureOffComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-colour-picker', createCustomElement(ColourPickerComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-cron-expression-input', createCustomElement(CronExpressionInputComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-theme-content', createCustomElement(ThemeContentComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-elapsed-time', createCustomElement(ElapsedTimeComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-knockout-form-wrapper', createCustomElement(KnockoutFormWrapperComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-knockout-nuclear-field', createCustomElement(KnockoutNuclearFieldComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-embedded-report', createCustomElement(EmbeddedReportComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-developer-menu-bar', createCustomElement(DeveloperMenuBarComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-tenancy-selection', createCustomElement(TenancySelectionComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-cmdb-default-infobox', createCustomElement(CmdbDefaultInfoboxComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-cmdb-infobox', createCustomElement(CmdbInfoboxComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-progress-dialog', createCustomElement(ProgressDialogComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-audit-history-journal-filter', createCustomElement(AuditHistoryJournalFilterComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-journal-attachment-selector', createCustomElement(JournalAttachmentSelectorComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-workflow-modal', createCustomElement(WorkflowModalComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-portal-modal', createCustomElement(PortalModalComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-catalog-modal', createCustomElement(QuestionModalComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-table-grid', createCustomElement(TableGridComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-import-transform-diagram', createCustomElement(ImportTransformDiagramComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-server-script-messages', createCustomElement(ServerScriptMessagesComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-rtf-editor', createCustomElement(RtfEditorComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-detail-tooltip', createCustomElement(DetailTooltipComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-version-tooltip', createCustomElement(VersionTooltipComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-question-overlay', createCustomElement(QuestionOverlayComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-action-question-overlay', createCustomElement(ActionQuestionOverlayComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-system-journal', createCustomElement(SystemJournalComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-system-journal-email', createCustomElement(SystemJournalEmailComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-system-journal-whatsapp', createCustomElement(SystemJournalWhatsappComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-locale-selector', createCustomElement(LocaleSelectorComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-locale-html-configuration', createCustomElement(LocaleHtmlConfigurationComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-modal-wrapper', createCustomElement(ModalWrapperComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-query-functions', createCustomElement(QueryFunctionsComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-expando', createCustomElement(ExpandoComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-second-factor-auth-page', createCustomElement(SecondFactorAuthPageComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-knowledge-article', createCustomElement(KnowledgePageComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-content-page-header', createCustomElement(ContentPageHeaderComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-content-page-footer', createCustomElement(ContentPageFooterComponent, {injector: this.injector}));

    // Renderers for field as web components
    this.defineIfNotExist('sb-ng-textfield-renderer', createCustomElement(TextFieldRendererComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-choice-renderer', createCustomElement(ChoiceRendererComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-switch-renderer', createCustomElement(SwitchRendererComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-date-renderer', createCustomElement(DateRendererComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-onetoone-renderer', createCustomElement(OneToOneRendererComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-image-lightbox', createCustomElement(ImageLightboxComponent, {injector: this.injector}));

    // Syncfusion ones
    this.defineIfNotExist('sb-ng-email-textfield-renderer', createCustomElement(EmailTextfieldRendererComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-ejs-dialog', createCustomElement(DialogComponent, {injector: this.injector}));

    this.defineIfNotExist('sb-ng-ejs-dropdownlist', createCustomElement(DropDownListComponent, {injector: this.injector}));

    // finally... ready to render the page!
    setTimeout(() => document.querySelector('html')?.classList.add('is-ready'));

    // .site-loader show/hide loading indicator
    this.eventService.requestInProgress.pipe(
      tap(isLoading => {
        if (isLoading) {
          if (this.siteLoaderElement) {
            this.siteLoaderElement.style.display = 'block';
          }
        }
      }),
      debounceTime(250),
      tap(isLoading => {
        if (!isLoading) {
          if (this.siteLoaderElement) {
            this.siteLoaderElement.style.display = 'none';
          }
        }
      }),
    ).subscribe();
  }

  defineIfNotExist( name: string, element: any) {
    if (!customElements.get(name)) {
      customElements.define(name, element);
    }
  }

  onNavigateModalFormModalCreated($event: any) {
    this.alertService.setNavigateModalFormModal(this.navigateModalFormModal);
  }
}
